import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import openHelpDeskSupport from 'app/utils/openHelpDeskSupport';

const SUPPORT_EMAIL = 'support@egb.com';

interface Props {
    embedded: boolean
    endDate: string
}

const PokerCoolOffStub = ({embedded, endDate}: Props): React.ReactElement => {
    const handleSupportClick = useCallback(() => {
        openHelpDeskSupport();
    }, []);

    return (
        <div className={`poker-cool-off-stub${embedded ? ' poker-cool-off-stub--embedded' : ''}`}>
            <h3 className="poker-cool-off-stub__title">{I18n.t('poker.cooling_off.title')}</h3>
            <p className="poker-cool-off-stub__description">
                {I18n.t('poker.cooling_off.description', {date: endDate})}
            </p>
            <p className="poker-cool-off-stub__support">
                {I18n.t('poker.cooling_off.support_1')}
                <button
                    className="poker-cool-off-stub__support-link"
                    onClick={handleSupportClick}
                    type="button"
                >
                    {I18n.t('poker.cooling_off.support_2')}
                </button>
                {I18n.t('poker.cooling_off.support_3')}
                <a
                    className="poker-cool-off-stub__support-link"
                    href={`mailto:${SUPPORT_EMAIL}`}
                >
                    {SUPPORT_EMAIL}
                </a>
            </p>
        </div>
    );
};

export default PokerCoolOffStub;
